import { render, staticRenderFns } from "./RelativeAnchor.vue?vue&type=template&id=1f7be497"
import script from "./RelativeAnchor.vue?vue&type=script&lang=js"
export * from "./RelativeAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports